const rowSizingCls = "_275rq5afvc";
const thead = "_275t1pewh48";
const mobileLeftSection = "_275mlb4z11";
const mobileHeadingCell = "_275mwfekc6";
const mobileMetaSection = "_275m1c5nkca";
const mobileMetaCell = "_275m1xfdst1";
const mobileMetaSeparator = "_275m7wxf4c";

export { mobileHeadingCell, mobileLeftSection, mobileMetaCell, mobileMetaSection, mobileMetaSeparator, rowSizingCls, thead };
import "./atom.table.style.linaria.module.css";
//# sourceMappingURL=atom.table.style.js.map
